/**
 * 一组内只允许有一个active为true的组别
 */
class RouteArr{
    activeRoute = null
    data = []
    hasDefalut = false

    constructor(routes, hasDefalut = false){
        this.data = routes
        this.data.forEach(r => r.active = false)
        if(hasDefalut){
            this.hasDefalut = hasDefalut
            this.setActive(this.data[0])
        }
    }

    setActive(route){
        if(this.activeRoute){
            this.activeRoute.active = false
        }
        route.active = true
        this.activeRoute = route
    }

    hideActive(){
        if(this.activeRoute){
            this.activeRoute.active = false
        }
        // 存在默认值时，隐藏时应选中默认值。
        if(this.hasDefalut){
            this.setActive(this.data[0])
        }
    }
}

export {
    RouteArr
}


// WEBPACK FOOTER //
// ./src/models/route-arr.js